module.exports = __webpack_public_path__ + "static/media/SolutionsFourth.c17361b1.png";